"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _ArrowLeft = _interopRequireDefault(require("@kyruus/react-ikons/ArrowLeft"));
var _button = _interopRequireDefault(require("@kyruus/button"));
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MobileHeader = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    activeStep,
    onGoBack,
    stepsConfiguration
  } = _ref;
  if (!stepsConfiguration) {
    return /*#__PURE__*/_react.default.createElement(_styles.Container, {
      "data-testid": "MobileHeaderSkeleton",
      ref: ref
    }, /*#__PURE__*/_react.default.createElement(_styles.MobileHeaderSkeleton, null));
  }
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "MobileHeader",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_styles.MobileHeaderContent, {
    className: "MobileHeaderContent"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    style: activeStep === 0 ? {
      visibility: 'hidden'
    } : {},
    mode: "flat",
    onClick: () => onGoBack(stepsConfiguration[activeStep - 1].stateKey)
  }, /*#__PURE__*/_react.default.createElement(_ArrowLeft.default, {
    "aria-hidden": true,
    size: "24px"
  }), ' ', /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.goBack)), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default[stepsConfiguration[activeStep].stepperLabelId])));
});
MobileHeader.displayName = 'MobileHeader';
MobileHeader.propTypes = {
  // active step to highlight
  activeStep: _propTypes.string.isRequired,
  // callback for 'back' click
  onGoBack: _propTypes.func.isRequired,
  // steps configuration object. see constants/steps
  stepsConfiguration: _propTypes.object
};
var _default = exports.default = MobileHeader;
MobileHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MobileHeader",
  "props": {
    "activeStep": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onGoBack": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "stepsConfiguration": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};